import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    userName:'',
    userInfo:null,
    token:null
  },
  mutations: {
		setUserName(state , newVal){
			state.userName=newVal
		},
		setUserInfo(state , newVal){
			state.userInfo=JSON.parse(newVal)
    },
    setToken(state , newVal){
			state.token=newVal
		},
  },
  actions: {

  }, 
  modules: {
    
  }
})
